import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendRequestAddToCustomerList,
  sendRequestToExecutorList,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  initState
} from '../reduce';

import { timeoutCall } from '../../../../../../../utils/sagaHalper';
import UserBlackListService from '../../../../../services/UserBlackListService';
import * as clientNoticesActions from '../../../../../../main/reducers/static/states/clientNotices/reducer';

function* addUserBlackListFormSaga(reducerName, apiServiceFunc) {
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(timeoutCall, apiServiceFunc, formBody);
    if (result) {
      if (result.status === 422) {
        yield put(setErrors(reducerName, result.data));
      } else if (result.status === 201) {
        yield put(initState(reducerName));
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: 'Пользователь добавлен в черный список'
          })
        );
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 201)
    );
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequestAddToCustomerList(reducerName).type,
      addUserBlackListFormSaga,
      reducerName,
      UserBlackListService.addUserBlackListToCustomerList
    ),
    takeEvery(
      sendRequestToExecutorList(reducerName).type,
      addUserBlackListFormSaga,
      reducerName,
      UserBlackListService.addUserBlackListToExecutorList
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/forms/addUserBlackListForm/sagas/addUserBlackListFormSaga.js